import React, { useState, useEffect } from "react";

import Layout from "../components/layout"
import SponsorsListing from "../components/sponsors-listing"

import { getAllSponsors } from "../sponsors";

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

function SponsorsPage(props) {
  const [sponsors, setSponsors] = useState(getAllSponsors());

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/sponsors", title: "Sponsors"});
  }, []);

  return (
    <Layout page="sponsors" title="Sponsors">
        <div style={{marginBottom: "200px"}}>
            <SponsorsListing sponsors={sponsors} />
        </div>
    </Layout>
  );
}

export default SponsorsPage;